export type ScheduleListPbxScopeMode = 'single-pbx' | 'all-accessible-at-zero'

export interface ScheduleListPbxScope {
  enabled: boolean
  pbxId?: number
}

export const resolveScheduleListPbxScope = (
  pbxId: number | undefined,
  mode: ScheduleListPbxScopeMode,
): ScheduleListPbxScope => {
  if (pbxId === undefined || !Number.isInteger(pbxId)) {
    return { enabled: false }
  }

  if (pbxId > 0) {
    return { enabled: true, pbxId }
  }

  if (pbxId === 0 && mode === 'all-accessible-at-zero') {
    return { enabled: true }
  }

  return { enabled: false }
}
